import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface CategoryPieChartProps {
  categoryData: CategoryData;
}

const CategoryPieChart: React.FC<CategoryPieChartProps> = ({ categoryData }) => {
  const pieChartData = Object.entries(categoryData.categoryCounts).map(([name, count]) => ({
    name,
    y: count  // Pie charts in Highcharts expect 'y' property, not 'value'
  }));

  const options = {
    chart: {
      type: 'pie',
      height: '400px'
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f}%'
        }
      }
    },
    series: [{
      name: 'Keywords',
      colorByPoint: true,
      data: pieChartData
    }],
    ...getExportingOptions('Category Distribution Pie')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CategoryPieChart;
